<!--
Component <base-search-box> element

Generic container to render cards

@example

  <base-card>
    <template v-slot:header>
      <some-custom-header />
    </template>

    <div class="m-card-layout-main">
      Main Content
    </div>

    <template v-slot:footer>
      <some-custom-footer />
    </template>

  </base-card>

-->

<template lang="html">
  <section>
    <div class="m-card">
      <header v-if="hasHeader" :class="headerClass">
        <slot name="header"></slot>
      </header>
      <main :class="mainClass">
        <slot></slot>
      </main>
      <footer v-if="hasFooter"><slot name="footer"></slot></footer>
    </div>
  </section>
</template>

<script lang="js">
  export default  {
    name: "base-card",
    props: {
      headerClass: String,
      noPadding: Boolean,
      noMargin: Boolean
    },
    computed: {
      mainClass() {
        return {
          "no-padding": this.noPadding,
          "no-margin": this.noMargin
        };
      },
      hasHeader() {
        return Boolean(this.$slots.header);
      },
      hasFooter() {
        return Boolean(this.$slots.footer);
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "@/styles/components/_elements";
  .m-card {
    @include mixin-box;
    font-size: 0.8125rem;
    border-radius: 0.25rem;
  }
  header,
  main,
  footer {
    box-sizing: border-box;
  }
  header {
    padding: 0.75rem 1rem 0;
    margin: 0 0 0.75rem;
  }
  main {
    margin: 0.75rem 0;
    padding: 0 1rem;
  }
  footer {
    padding: 0.75rem 1rem;
    margin: 0.75rem 0 0;
    border-top: 1px solid var(--LIGHT_GRAY, #dddbda);
  }
  .no-padding {
    padding: 0;
  }
  .no-margin {
    margin: 0;
  }
</style>
